import { InstallChapter, SendEventsChapter, IdentifyUsersChapter, UserPropertiesChapter, ActionsAndInsightsChapter, GroupAnalyticsChapter, EstimatingUsageChapter } from "components/GettingStarted";
import SignupLink from "components/SignupLink";
import * as React from 'react';
export default {
  InstallChapter,
  SendEventsChapter,
  IdentifyUsersChapter,
  UserPropertiesChapter,
  ActionsAndInsightsChapter,
  GroupAnalyticsChapter,
  EstimatingUsageChapter,
  SignupLink,
  React
};